export const Colors = {
    buttonColor: '#44A08D',
    buttonHoverColor: '#3E8E41',
    buttonActiveColor: '#2E6E33',
    primaryColor:'#00162C',
    primaryColor1:'#B73E00',
    bg:'#090D12',
    bgcard:'#242424',
    secondary:'white',
    inputbg:'#D9D9D9'
};
export default Colors;